var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#add_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.688.831c-.253.08-.52.336-.627.6l-.057.141-.006 4.686-.007 4.686-4.733.006-4.734.006-.157.075a1.07 1.07 0 0 0-.488.487c-.07.147-.075.176-.075.423 0 .25.004.273.077.421.076.153.236.335.38.431.039.026.14.07.224.095.15.047.23.048 4.83.048h4.676l.007 4.746.006 4.746.057.14c.11.273.378.524.643.603.158.047.434.047.592 0 .265-.078.533-.33.643-.603l.057-.14.006-4.746.007-4.746h4.677c4.599 0 4.68 0 4.83-.048.083-.026.184-.069.224-.095.143-.096.303-.277.379-.43.073-.15.077-.173.077-.422 0-.247-.005-.276-.075-.423a1.07 1.07 0 0 0-.487-.487l-.158-.075-4.734-.006-4.733-.006-.007-4.686-.006-4.686-.057-.14c-.11-.273-.378-.525-.643-.603a1.4 1.4 0 0 0-.608.002",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "add_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgAdd;